import { grey } from "@mui/material/colors";

const styles = {
  container: {
    my: 2,
    width: "100%",
    justifyContent: "space-between",
  },
  orText: {
    color: grey[700],
    textAlign: "center",
    mx: 2,
  },
  border: {
    border: "0.5px solid rgba(0, 0, 0, 0.2)",
  },
};

export default styles;
